import React from 'react'

export default function UserRemarksSection({
  userRemarks,
  rewards,
}: Readonly<{
  userRemarks?: string
  rewards?: number
}>) {
  let message = ''

  if (userRemarks) {
    message = userRemarks
  } else if (rewards === 0) {
    message = 'Unlock potential for more surveys by completing this survey'
  }

  return message ? (
    <div className='w-full rounded-lg border border-stroke-darker bg-pop-gray-7 p-2 text-left text-xs font-normal text-pop-grey-900'>
      {message}
    </div>
  ) : null
}
